// IE11 doesn't support forEach
// Array.prototype.forEach supported since IE9
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}